/**
 * @param {{ tokenKey:string, refreshTokenKey:string }} options
 * @returns {{ token:string, refreshToken:string }}
 */
export const cookieExtractTokenInfo = (options) => {
    const { cookie } = window.document;
    let info = { token: undefined, refreshToken: undefined };
    try {
        const { tokenKey, refreshTokenKey } = options;
        const hash = cookie.split('; ').reduce((acc, str) => {
            const [key, val] = str.split('=');
            return { ...acc, [key]: val };
        }, {});
        info.token = hash[tokenKey];
        info.refreshToken = hash[refreshTokenKey];
    } catch (error) {
        // noop
    }
    return info;
};
